import { render, staticRenderFns } from "./CountryPoliciesComparison.vue?vue&type=template&id=2602225c&"
import script from "./CountryPoliciesComparison.vue?vue&type=script&lang=js&"
export * from "./CountryPoliciesComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports